import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/dividend-growth-calculator',
  component: () => import('../../routes/DividendGrowthCalculator.svelte'),
  card: {
    id: 'dividend-growth-calculator',
    title: 'Dividend Growth Rate',
    description: 'Calculate the compound annual growth rate of a dividend and project future dividend income over time.',
    icon: 'trending_up',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/dividend-growth-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Dividend Growth Rate Calculator – CAGR of Dividend Income',
    description: 'Free dividend growth rate calculator to find the compound annual growth rate (CAGR) of your dividend payments. Project future dividend income and see how dividend growth investing compounds over time.',
  },
};

export default meta;
